<template>
    <div class="obrazec obnova ovoj" id="html">
        <div class="glava">
            <div class="levi-logo">
              <img src='~@/assets/ikc.png'/>
            </div>
            <div class="desni-info">
                <p>Pivola 8, SI2311 Hoče</p>
                <p>Tel.: (02) 613 08 31, -32</p>
                <p>info@ikc-um.si</p>
                <p><a href="www.ikc-um.si">www.ikc-um.si</a></p>
            </div>
        </div>
		<div class="noga-izven">
        		<div class="stevilka-strani" >E_Obr. 4.78_1, rev. 00, 14.4.2023, stran </div>
        		<div class="info">Pivola 8, SI-2311 Hoče, telefon: + 386 (0)2 6130831, -32, e-mail: info@ikc-um.si, www.ikc-um.si</div>
      	</div>
        <div id="vsebina">
		<kbutton class="gumbtiskaj" :theme-color="'primary'" :rounded="'full'" id="tiskaj">
			<font-awesome-icon icon="print"  size="6x"/>
		</kbutton>
		<div class="zapisnik-glava">
			<h2>ZAPISNIK O OPRAVLJENEM KONTROLNEM PREGLEDU NA KRAJU SAMEM</h2>
		</div>


		<table class="zapisnik-podatki mt-1">
			<colgroup>
				<col style="width:25%">
				<col style="width:auto">
			</colgroup>  
			<tr>
				<td class="td-bold">Shema certificiranja</td>
				<td>IP</td>
			</tr>
			<tr>
				<td class="td-bold">Področje</td>
				<td>{{podrocjaip.find(g=>g.naziv==kontrola.podrocjecertificiranja)?podrocjaip.find(g=>g.naziv==kontrola.podrocjecertificiranja).prikaz:''}}
				 </td>
			</tr>
		</table>

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:25%">
				<col style="width:75%">
			</colgroup>  
			<tr>
				<td class="td-bold">Normativni dokument</td>
				<td>{{podatkiGlave.find(g=>g.sifra==kontrola.podrocjecertificiranja)?podatkiGlave.find(g=>g.sifra==kontrola.podrocjecertificiranja).predpis:''}}</td>
			</tr>
			<tr>
				<td class="td-bold">Pravna podlaga</td>
				<td>1.80doc – Pravila postopka certificiranja v svoji veljavni reviziji</td>
			</tr>
			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Podatki o izvajalcu</td>
			</tr> 
			<tr>
				<td>Naziv</td>
				<td>{{ nosileckmg.naziv }}</td>
			</tr>
			<tr>
				<td >Kontrolna številka</td>
				<td>{{ pridelovalec.kontrolnaStevilka }}</td>
			</tr>
			<tr>
				<td >Naslov</td>
				<td>{{ nosileckmg.naslov }}</td>
			</tr>
			<tr>
				<td >Pošta številka</td>
				<td>{{ nosileckmg.postnastevilka }} {{ nosileckmg.posta }}</td>
			</tr>
			<tr>
				<td >Telefonska št.</td>
				<td>{{ nosileckmg.telefon.join(",") }}</td>
			</tr>
			<tr>
				<td >Elektronski naslov</td>
				<td>{{ nosileckmg.email.join(",") }}</td>
			</tr>
			<tr>
				<td >Naslov KMG</td>
				<td>{{ kontaktkmg.naslov }}, {{ kontaktkmg.postnastevilka }} {{ kontaktkmg.posta }}</td>
			</tr>
			<tr>
				<td >KMG-MID</td>
				<td>{{ pridelovalec.kmgmid }}</td>
			</tr>

			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Podatki o članu (skupinsko certificiranje)</td>
			</tr> 
			<tr>
				<td>Naziv</td>
				<td>{{ nosileckmg.naziv }}</td>
			</tr>
			<tr>
				<td >Kontrolna številka</td>
				<td>{{ pridelovalec.kontrolnaStevilka }}</td>
			</tr>
			<tr>
				<td >Naslov</td>
				<td>{{ nosileckmg.naslov }}</td>
			</tr>
			<tr>
				<td >Pošta številka</td>
				<td>{{ nosileckmg.postnastevilka }} {{ nosileckmg.posta }}</td>
			</tr>
			<tr>
				<td >Telefonska št.</td>
				<td>{{ nosileckmg.telefon.join(",") }}</td>
			</tr>
			<tr>
				<td >Elektronski naslov</td>
				<td>{{ nosileckmg.email.join(",") }}</td>
			</tr>


			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Podatki o kontrolnem pregledu - nadzoru</td>
			</tr> 
			<tr>
				<td>Št. zapisnika / kontrole</td>
				<td>{{ kontrola.zaporednastevilka }}</td>
			</tr>
			<tr>
				<td >Datum</td>
				<td>{{ kontrola.datumkontrole.toLocaleDateString('SL-si') }}</td>
			</tr>
			<tr>
				<td >Vrsta nadzora</td>
				<td>{{ kontrola.vrstakontrole }}</td>
			</tr>
			<tr>
				<td >Lokacija nadzora</td>
				<td>{{ kontrola.lokacijakontrole }}</td>
			</tr>
			<tr>
				<td >Kontrolor</td>
				<td>{{ kontrola.kontrolornaziv }}</td>
			</tr>
			<tr>
				<td >Prisoten izvajalec / pooblaščenec</td>
				<td >
				<div class="multi-td">
				<div>{{ kontrola.prisotnaoseba.ime}} ({{ kontrola.prisotnaoseba.status.naziv}})</div>
				<div class="fake-td">Pooblastilo na voljo</div>
			<div>{{ kontrola.pooblastilo }}</div>
		</div>
		</td>
			</tr>
			<tr>
				<td>Dokument, na podlagi katerega je ugotovljena istovetnost prisotne odgovorne osebe</td>
				<td>{{ kontrola.dokumentpooblastila}}</td>
			</tr>
			<tr>
				<td >Prisotne druge osebe</td>
				<td>{{ kontrola.drugeprisotneosebe.join(", ")}}</td>
			</tr>
			<tr>
				<td >Začetek kontrole</td>
				<td >
				<div class="multi-td">
				<div>{{ kontrola.zacetekkontrole.toLocaleDateString('SL-si') }}</div>
				<div class="fake-td">Skupaj ure</div>
			<div>{{ kontrola.trajanje }}</div>
		</div>
		</td>
			</tr>
			<tr>
				<td >Konec kontrole</td>
				<td>{{ kontrola.koneckontrole.toLocaleDateString('SL-si')}}</td>
			</tr>
			
			<tr>
				<td >Vzorčenje</td>
				<td >
					<div class="multi-td">
						<div>{{ kontrola.vzorcenje?"DA":"NE" }}</div>
						<div class="fake-td">Št. vzorca</div>
						<div>{{ kontrola.vzorci.map(i=>i.idvzorca).join(",") }}</div>
					</div>
				</td>
			</tr>

		</table>


		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:25%">
				<col style="width:75%">
			</colgroup>  
		<tr>
				<td >Ogled ostalih enot izvajalca</td>
				<td>{{ kontrola.ogledenot}}</td>
			</tr>
		</table>

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:25%">
				<col style="width:75%">
			</colgroup>  
			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Obseg certificiranja</td>
			</tr> 
			<tr>
				<td >Po seznamu iz dne</td>
				<td>{{ ip.prijava.datumseznama?ip.prijava.datumseznama.toLocaleDateString('SL-si'):""}}</td>
			</tr>
			<tr>
				<td >Obseg:</td>
				<td>{{ ip.prijava.obseg[kontrola.podrocjecertificiranja].map(i=>i.naziv).join(", ")}}</td>
			</tr>
			

		</table>

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:50%">
				<col style="width:50%">
			</colgroup>  
		<tr>
				<td >Ob kontroli so bile ugotovljene neskladnosti</td>
				<td>{{ kontrola.neskladnosti}}</td>
			</tr>
		</table>
	

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:15%">
				<col style="width:20%">
				<col style="width:25%">
				<col style="width:5%">
				<col style="width:20%">
				<col style="width:15%">
				
			</colgroup>  
			<tr>
				<td colspan="6" class="zapisnik-tabela-glava">Neskladja</td>
			</tr> 
			<tr>
				<th>Kont. Tč.</th>
				<th>Opis zahteve</th>
				<th>Komentar</th>
				<th>Stopnja neskladja</th>
				<th>Ukrep</th>
				<th>Rok</th>
			</tr> 

			<tr v-for="neskladje in kontrola.neskladja.filter(n=>n.skladnost=='NE')" :key="neskladje._id">
				<td>{{neskladje.kontrolnatocka}}</td>
				<td>{{neskladje.opis}}</td>
				<td>{{neskladje.komentar}}</td>
				<td>{{neskladje.stopnjaneskladja}}</td>
				<td>{{neskladje.ukrep}}</td>
				<td>{{(new Date(neskladje.rok)).toLocaleDateString('SL-si')}}</td>
			</tr> 
		</table>

		

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:15%">
				<col style="width:20%">
				<col style="width:50%">
				<col style="width:15%">
				
			</colgroup>  
			<tr>
				<td colspan="4" class="zapisnik-tabela-glava">Nadaljnji ukrepi</td>
			</tr> 
			<tr>
				<th>Kont. Tč.</th>
				<th>Opis zahteve</th>
				<th>Nadaljnji ukrep</th>
				<th>Rok</th>
			</tr> 

			<tr v-for="ukrep in kontrola.ukrepizvajalca" :key="ukrep._id">
				<td>{{ukrep.knttocka}}</td>
				<td>{{ukrep.ukrep}}</td>
				<td>{{ukrep.ukrep}}</td>
				<td>{{ukrep.rok.toLocaleDateString('SL-si')}}</td>
			</tr> 
		</table>


		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:20%">
				<col style="width:80%">
				
			</colgroup>  
			<tr>
				<td colspan="2" class="zapisnik-tabela-glava">Priloge zapisnika</td>
			</tr> 
			<tr v-for="priloga of kontrola.priloge" :key="priloga.imepriloge">
				<td>{{priloga.imepriloge}}</td>
				<td>{{priloga.nazivpriloge}}</td>
			</tr> 
			<!-- data repeta this tr-->
		</table>

		<!--
		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:20%">
				<col style="width:80%">
				
			</colgroup>  
			
			<tr>
				<td>Kont. Tč.</td>
				<td>Ime priloge</td>
			</tr> 
		
		</table>
	-->
		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:100%">
			
			</colgroup>  
			<tr>
				<td colspan="1" class="zapisnik-tabela-glava">Povzetek kontrole</td>
			</tr> 
			<tr>
				<td rowspan="4" class="td-regular" style="white-space: pre-wrap;">{{kontrola.povzetekkontrole}}</td>	
			</tr> 
			<!-- data repeta this tr-->
		</table>

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:100%">
			</colgroup>  
			<tr>
				<td colspan="1" class="zapisnik-tabela-glava">ZUP</td>
			</tr> 
			<tr>
				<td class="td-regular">Seznanjen/a sem z vsebino kontrolnih poročil in z vsebino prilog ter ob kontroli zapisanimi podatki. Zapisnik je prebran prisotni stranki (izvajalcu) oz. pooblaščencu. Na prebrano in zapisano vsebino kontrolnih poročil: </td>	
			</tr> 
			<tr>
				<td class="td-regular">
					<div class="display-row">
					<input type="checkbox" v-if="kontrola.zuppripombe"  checked  class="k-checkbox" />
					<input type="checkbox" v-if="!kontrola.zuppripombe"   class="k-checkbox" />
					<span>Nimam pripomb</span>
					</div>
				</td>	
			</tr> 
			<tr>
				<td class="td-regular">
					
					<div class="display-row">
					<input type="checkbox" v-if="!kontrola.zuppripombe"  checked  class="k-checkbox" />
					<input type="checkbox" v-if="kontrola.zuppripombe"   class="k-checkbox" />
					<span>Imam naslednje pripombe:</span>
					<span>{{ kontrola.zuppripomba }}</span>
					</div>

				</td>	
			</tr> 
			<tr>
				<td class="td-regular">&nbsp;</td>	
			</tr> 
			<tr>
				<td class="td-regular">

					<div>Zapisnik je napisan v dveh izvodih, od katerega en izvod pripada izvajalcu:</div>
					<div class="display-row">
						<input v-if="kontrola.zupposlannaemail" type="checkbox" checked  class="k-checkbox" />
						<input v-if="!kontrola.zupposlannaemail" type="checkbox"  class="k-checkbox" />
						<span>Posredovan v obliki pdf na e-naslov:</span>
						<span>{{  kontrola.zupemail }} </span>
					</div>
					<div class="display-row">
						<input v-if="kontrola.zupprevzetnasedezu" type="checkbox" checked  class="k-checkbox" />
						<input v-if="!kontrola.zupprevzetnasedezu" type="checkbox"  class="k-checkbox" />
						<span>Zapisnik se posreduje izvajalcu v pisni obliki iz sedeža IKC UM </span>
					</div>
					<label for="pripombe" class="display-row">
					<input v-if="kontrola.zupprevzetobkontroli" type="checkbox" checked  class="k-checkbox" />
					<input v-if="!kontrola.zupprevzetobkontroli" type="checkbox"  class="k-checkbox" />
					<span>Zapisnik je bil predan v tiskani obliki izvajalcu ob kontroli </span>
					</label>
		

				</td>	
			</tr> 
			<!-- data repeta this tr-->
		</table>


		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:13%">
				<col style="width:12%">
				<col style="width:25%">
				<col style="width:25%">
				<col style="width:25%">
				
				
			</colgroup>  
			<tr>
				<th>Kraj</th>
				<th>Datum</th>
				<th>Podpis kontrolorja</th>
				<th>Podpis izvajalca oz. pooblaščenca</th>
				<th>Podpisi drugih prisotnih oseb</th>
				
			</tr> 
			
			<tr>
				<td  class="td-regular" rowspan="2" style="line-height: 3rem;">
					{{ kontrola.lokacijakontroleposta }}
				</td>
				<td rowspan="2" style="line-height: 3rem;">
				{{ kontrola.koneckontrole.toLocaleDateString('SL-si') }}</td>
				<td rowspan="2">&nbsp;</td>
				<td rowspan="2">&nbsp;</td>
				<td rowspan="2">&nbsp;</td>
			</tr>
			
			
		</table>

		
	
    </div>
    </div>
   

</template>

<style scoped>

	
	.gumbtiskajskrit {
            display:none;
        }
	.zapisnik-glava{
		
		background-color:#d9d9d9;
		border:1px solid black;
		text-align: center;
		padding:1mm;
	
	}
	.zapisnik-glava h2{
		color:black;

	}
	table.zapisnik-podatki {
		width:100%;
	}
	table.zapisnik-podatki, table.zapisnik-podatki td{
		border: 1px solid black;
		border-collapse: collapse;
		
	} 
	table.zapisnik-podatki td{
		padding-left: 1mm;
		padding-right: 1mm;
	}
	table.zapisnik-podatki td .multi-td{
		display:flex;
		border:none;
		 align-items: stretch;
		  height: 100%;
	}
	table.zapisnik-podatki td .multi-td div{
		flex: 1 1 33%;
		padding-left: 1mm;
		padding-right: 1mm;

	}
	table.zapisnik-podatki td .multi-td div:first-child{
		
		padding-left: 0;
		

	}
	table.zapisnik-podatki th{
		font-weight: normal;
		background-color:#d9d9d9;
		text-align: left;
		border: 1px solid black;
		border-collapse: collapse;
		padding-left: 1mm;
		padding-right: 1mm;
	}
	table.zapisnik-podatki td:first-child,.fake-td{
		background-color:#d9d9d9;
		border-left:1px solid black;
		border-right:1px solid black;
		
	}
	.td-bold {
		font-weight: bold;
	}
	table.zapisnik-podatki td.td-regular {
	background-color:white;
	}
	.zapisnik-tabela-glava {
		background-color:var(--accent) !important;
		color:black;
		font-weight: bold;;

	}
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}


h1,h2,h3{
  font-size:5mm;
  line-height:5mm;
}

@media print {
.sekcija-nb {
  break-inside: avoid!important;
	  }
}

.noga-noter {

display:    flex ;
flex-direction:     row ;
justify-content:    end;
margin-top:2rem;
}

.datum,.podpis {
  margin-right: 10rem;
  font-size: 1rem;
}


.tabela-kultura-wrapper {
  column-count:2;
  
}
.tabela-proizvod-wrapper {
  column-count:3;
  
}
.tabela{
  width: 100%;
  table-layout: fixed;
}
.tabela th {
  font-size: 0.5rem;
}


.tabela td,.tabela,.tabela th {
  
  border: 1px solid green;
  border-collapse: collapse;
  padding:3px;
  font-size: 0.7rem;
}

label,textarea{
  break-inside: avoid !important;
   
}
.glava{
  
  display:    flex ;
  flex-direction:     row ;
  justify-content:    space-between  ;

}
.levi-logo  {
 position:   running(obrazecLeviLogo); 
}  

.levi-logo img{
  height: 2cm;

}
.desni-info {
  position:   running(obrazecDesniInfo);
}

.desni-info p{
  
  margin: 0;
  font-size:  0.4cm;
  line-height:   0.4cm;
  text-align:     right   ;
}



.noga {

  position:   running(obrazecNoga);
  font-size: 3mm ;
  line-height:5mm;
  display:    flex ;
  flex-direction:     row ;
  justify-content:    space-between;
}

.stevilka-strani:after{
content: counter(page) " od " counter(pages);
}


label.k-form-field{
  font-weight:    bold;
  font-size:  0.8em;
  line-height:    0.8em;
  margin-top:2mm;
  margin-bottom:1mm;
}
.posta input:nth-child(1){
  flex-basis: 15%;
  margin-right: 3mm;

}
h6{
  font-size: 0.7em;
}

.sekcija {
  margin-top:5mm;
  border:   1px solid green;
  padding: 2mm;
 
}
.sekcija-pb1 {
  padding-bottom:1mm;
}

.posebnosti .seznamkategorij
{
  border-bottom:  1px solid green;
}
.izjava ul{
  list-style-type: disc;
margin-top: 3mm;
margin-bottom: 3mm;
margin-left: 0;
margin-right: 0;
padding-left: 10mm;
}
.vrsticapodpisa div {
  flex-basis: 50%;
}
.noga-izven{
position:  running(nogaRunning);
font-size: 3mm ;
line-height:5mm;

}

.zacetek-strani {
break-before: always;
}

@page {

margin-top: 20mm;
margin-bottom: 20mm;
margin-left: 10mm;
margin-right: 10mm;
size: A4 portrait;

@bottom-center {
content:  element(nogaRunning);
vertical-align: top;
}
@top-left {
content:  element(obrazecLeviLogo);
vertical-align: middle;
}

@top-right {
content:  element(obrazecDesniInfo);
vertical-align: middle;
}


}


</style>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { Input } from '@progress/kendo-vue-inputs';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { MultiSelect,DropDownList,ComboBox } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';

import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { sifrant } from '../store/sifrant.module';
import { kontrolaService } from '../services/kontrola.service';

import { Previewer,registerHandlers,Handler  } from 'pagedjs';


class RepeatingTableHeaders extends Handler {
 
	
    constructor(chunker, polisher, caller) {
        super(chunker, polisher, caller);
        this.splitTablesRefs = [];
    }
	beforeParsed(content) {
		//console.log("Before preview!!!!!!!!!!!!!!!!!!!!!!")
		console.log(content);
		let gumbtiskaj=content.getElementById('tiskaj');
		//console.log("najdem gumb tiskaj")
		gumbtiskaj.remove();
		this.gumbtiskaj=gumbtiskaj;
	}
	afterPreview(content, renderTo) {
		let gumbtiskaj=this.gumbtiskaj;
		console.log("After preview!!!!!!!!!!!!!!!!!!!!!!")
		console.log(this.gumbtiskaj);
		gumbtiskaj.style.position="fixed";
		gumbtiskaj.style.top="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.onclick=function(){
			this.remove();
			window.print();
			document.body.appendChild(this);
		}
		document.body.appendChild(this.gumbtiskaj);
		}

    afterPageLayout(pageElement, page, breakToken, chunker) {
		console.log("after afterPageLayout!!!!!!!!!!!!!!!!!!!!!!")
        this.chunker = chunker;
        this.splitTablesRefs = [];

        if (breakToken) {
            const node = breakToken.node;
            const tables = this.findAllAncestors(node, "table");
            if (node.tagName === "TABLE") {
                tables.push(node);
            }

            if (tables.length > 0) {
                this.splitTablesRefs = tables.map(t => t.dataset.ref);

                //checks if split inside thead and if so, set breakToken to next sibling element
                let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
                if (thead) {
                    let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
                    breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
                }

                this.hideEmptyTables(pageElement, node);
            }
        }
    }

    hideEmptyTables(pageElement, breakTokenNode) {
        this.splitTablesRefs.forEach(ref => {
            let table = pageElement.querySelector("[data-ref='" + ref + "']");
            if (table) {
                let sourceBody = table.querySelector("tbody > tr");
                if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
                    table.style.visibility = "hidden";
                    table.style.position = "absolute";
                    let lineSpacer = table.nextSibling;
                    if (lineSpacer) {
                        lineSpacer.style.visibility = "hidden";
                        lineSpacer.style.position = "absolute";
                    }
                }
            }
        });
    }

    refEquals(a, b) {
        return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
    }

    findFirstAncestor(element, selector) {
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                return element.parentNode;
            }
            element = element.parentNode;
        }
        return null;
    }

    findAllAncestors(element, selector) {
        const ancestors = [];
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                ancestors.unshift(element.parentNode);
            }
            element = element.parentNode;
        }
        return ancestors;
    }

    // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
    layout(rendered, layout) {
        this.splitTablesRefs.forEach(ref => {
            const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
            if (renderedTable) {
                // this event can be triggered multiple times
                // added a flag repeated-headers to control when table headers already repeated in current page.
                if (!renderedTable.getAttribute("repeated-headers")) {
                    const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
                    this.repeatColgroup(sourceTable, renderedTable);
                    this.repeatTHead(sourceTable, renderedTable);
                    renderedTable.setAttribute("repeated-headers", true);
                }
            }
        });
    }

    repeatColgroup(sourceTable, renderedTable) {
        let colgroup = sourceTable.querySelectorAll("colgroup");
        let firstChild = renderedTable.firstChild;
        colgroup.forEach((colgroup) => {
            let clonedColgroup = colgroup.cloneNode(true);
            renderedTable.insertBefore(clonedColgroup, firstChild);
        });
    }

    repeatTHead(sourceTable, renderedTable) {
        let thead = sourceTable.querySelector("thead");
        if (thead) {
            let clonedThead = thead.cloneNode(true);
            renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
        }
    }

    // the functions below are from pagedjs utils/dom.js
    nodeAfter(node, limiter) {
        if (limiter && node === limiter) {
            return;
        }
        let significantNode = this.nextSignificantNode(node);
        if (significantNode) {
            return significantNode;
        }
        if (node.parentNode) {
            while ((node = node.parentNode)) {
                if (limiter && node === limiter) {
                    return;
                }
                significantNode = this.nextSignificantNode(node);
                if (significantNode) {
                    return significantNode;
                }
            }
        }
    }

    nextSignificantNode(sib) {
        while ((sib = sib.nextSibling)) {
            if (!this.isIgnorable(sib)) return sib;
        }
        return null;
    }

    isIgnorable(node) {
        return (node.nodeType === 8) || // A comment node
            ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
    }

    isAllWhitespace(node) {
        return !(/[^\t\n\r ]/.test(node.textContent));
    }

}

registerHandlers(RepeatingTableHeaders);



export default {
  components:{
	'kinput': Input,
	'kbutton': Button,
	'kendo-datepicker': DatePicker,
	'kendodatetimepicker': DateTimePicker,
    'multiselect': MultiSelect,
    'kendo-checkbox': Checkbox,
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
      'combobox': ComboBox,
      'dropdownlist': DropDownList,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko,
	  upload: Upload,
  },
  props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
			ipobsegcertificiranjafilter:{},
			ip:{},
			podatkiGlave:[{
sifra:"IPS",
naslov:"Kontrolne točke IPSO (Ta priloga je sestavni del zapisnika)",
podrocje:"Integrirana pridelava sadja in oljk (IPSO)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprem. in dop.) ",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.52, rev. 08, 12.4.2023",
},
{
sifra:"IPP",
naslov:"Kontrolne točke IPP (Ta priloga je sestavni del zapisnika)",
podrocje:"Integrirana pridelava poljščin (IPP)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprem. in dop.)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.53, rev. 07, 07.4.2023",
},
{
sifra:"IPZ",
naslov:"Kontrolne točke IPZ (Ta priloga je sestavni del zapisnika)",
podrocje:"Integrirana pridelava zelenjave (IPZ)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprem. in dop.)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.54, rev. 07, 12.4.2023",
},
{
sifra:"IPG",
naslov:"Kontrolne točke IPG (Ta priloga je sestavni del zapisnika)",
podrocje:"Integrirana pridelava grozdja (IPG)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprem. in dop.)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.55, rev. 07, 18.4.2023",
},
{
sifra:"IPH",
naslov:"Kontrolne točke IPH (Ta priloga je sestavni del zapisnika)",
podrocje:"Področje	Integrirana pridelava hmelja (IPH)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprem. in dop.)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.56, rev. 07, 18.4.2023",
},
],
            kontrola:{
				podrocjecertificiranja:"",
				status:"",
				stkontrole:0,
				datumnadzora:new Date(),
				vrstakontrole:"",
				lokacijakontrole:"",
				zacetekkontrole:new Date(),
				koneckontrole:new Date(),
				trajanje:0,
				gumbtiskaj:"gumbtiskajskrit",
				vzorcenje:true,
				vzorci:[],
				neskladja:[],
				prisotneosebe:[],
				seznam:[],
				storitvepodizvajalca:[],
				podizvajalci:[{naziv:"",naslov:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				storitvepodizvajalca:[{naziv:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				neskladnosti:"",
				posebnosti:"",
				ponovna:"",
				zuppripombe:false,
				zuppripomba:"",
				zupposlannaemail:"", //email iz podatkov
				zupprevzetnasedezu:"",
				zupprevzetobkontroli:"",
				zakljuceno:"",
				izvajalcikontrole:[{naziv:"",datum:new Date(),edit:true}]
			},
			files:[],
			kontrolorji:[],
			kontaktkmg:{naslov:"",posta:"",postnastevilka:""},
			nosileckmg:{naslov:"",posta:"",postnastevilka:""},
			sifrantTree:{},
			podrocjaip:[],
            dataLoading:false,
			podrocjacertificiranja:[{"naziv":"IPS","id":1, "prikaz":"IPSO"},{"naziv":"IPG","id":2, "prikaz":"IPG"},{"naziv":"IPP","id":3, "prikaz":"IPP"},{"naziv":"IPZ","id":4, "prikaz":"IPZ"},{"naziv":"IPH","id":5, "prikaz":"IPH"}],
           statusnadzora:[
			{id:1,naziv:"nova"},
			{id:2,naziv:"v teku"},
			{id:3,naziv:"odločitev"},
			{id:4,naziv:"konec"},
		   ],
		   statusprisotnihoseb:[
			{id:1,naziv:"izvajalec"},
			{id:2,naziv:"pooblaščenec"},
			{id:3,naziv:"ostali prisotni"},
			
		   ],
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' } 
            ],
            columns: [

               { field: "zaporednastevilka", title:"ID nadzora",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editable:false},
			   { field: "statusnadzora", title:"Status nazdora",width: "150px"},
			   { field: "shema", title:"shema"},
			   { field: "podrocje", title:"podrocje"},
			   { field: "izvajalec", title:"izvajalec"},
			   { field: "naslov", title:"naslov"},
			   { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "trajanje", title:"Trajanje (h)",width: "80px",filterable:false,type:"number",editor:"numeric",format:"{0:n2}"},
            
			   { field: "vrstakontrole", title:"Vrsta kontrole",width: "150px"},
			   { field: "kontrolor", cell:"kontrolor", title:"Kontrolor",width: "240px"},
               { field: "mnenjekontrolorja", title:"Mnenje",width: "90px"},
             
			   { field: "tveganje", title:"Ocena tveganja"},
			   { field: "cena", title:"cena"},
			   { field: "statusplacila", title:"Status plačila"},
			 
                //{ field: "vzorci", title:"Vzorci",width: "100px"},
                //{ field: "posebnosti", title:"Posebnosti",width: "100px"},
                //{ field: "priloge", title:"Priloge",width: "100px"},
                //{ field: "sifrakontrolorja", title:"Kontrolor",width: "100px"},
              /*   { field: "kolicina", title:"Količina",width: "100px",filterable:false,type: "number",footerCell: this.nogaVsotaKolicina,width: "150px",format: '{0:n2}'},
                { field: "merskaenotanaziv", title:"Enota",width: "100px",filterable:false},
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable:false, title:"Datum določitve statusa",width: "170px", cell:this.formatDate},
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
               // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title:"Status",width: "150px"},
                */
                { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrola.kontrola;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
        kontrolorjiSifrant(){
          return this.kontrolorji.map(i=>{
                i.naziv=i.priimek+' '+i.ime;
                return i;            
          })
        }
      
           },
	 
beforeDestroy() {
  //window.removeEventListener('beforeunload', this.beforeWindowUnload)
},
    created () {
	//	window.addEventListener('beforeunload', this.beforeWindowUnload)
 if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
		
	  this.naloziPodatke();

      
    },
  


    methods: {
		confirmLeave() {
    return window.confirm('Zapuščate stran. Ali ste shranili vse spremembe?')
  },

  confirmStayInDirtyForm() {
	//tukaj lahko preverim, če se je kaj spremnijalo...
    return !this.confirmLeave()
  },

  beforeWindowUnload(e) {
    if (this.confirmStayInDirtyForm()) {
      // Cancel the event
      e.preventDefault()
      // Chrome requires returnValue to be set
      e.returnValue = ''
    }   
  },
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne','save']),
        ...mapActions('kontrola', ['load','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrola',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
        formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
		izracunajtrajanje(){
			//var diff =(this.kontrola.zacetekkontrole.getTime() - this.kontrola.koneckontrole.getTime()) / 1000;
			var duration = moment.duration(moment(this.kontrola.koneckontrole).diff(this.kontrola.zacetekkontrole));
  			//let minutes =diff/60;
			//let hours=minutes/60;
			//let lefminutes=minutes%60
			//Math.abs(Math.ceil(diff))
  			Vue.set(this.kontrola,"trajanje",Math.floor(duration.as('h'))+moment.utc(Math.round(duration.as('ms')/(1000*5*60))*1000*5*60).format(':mm'));
			
		},
		dodajvzorcenje(){
            if(!this?.kontrola?.vzorci)
                this.kontrola.vzorci=[];

            const newRecord = { 
				id:0,
				datumvzorcenja:new Date(),
				datumizvida:new Date(),
				idporocila:0,
				datumpregleda:new Date,
				pregledizvedel:"",
				skladno:true,
				opomba:'',
				edit:true};

				this.kontrola.vzorci.push(newRecord);
        }   ,
        removevzorcenje(e){
        
                var index=this.kontrola.vzorci.indexOf(e);
                if(index>=0)
                        this.kontrola.vzorci.splice(index,1)

        },
        vzorcenjechange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajprisotneosebe(){
            if(!this?.kontrola?.prisotneosebe)
                this.kontrola.prisotneosebe=[];

            const newRecord = { 
				ime:"",
				podjetjekmg:"",
				funkcija:"",
				status:"",
				edit:true};

				this.kontrola.prisotneosebe.push(newRecord);
        }   ,
        removeprisotneosebe(e){
        
                var index=this.kontrola.prisotneosebe.indexOf(e);
                if(index>=0)
                        this.kontrola.prisotneosebe.splice(index,1)

        },
        prisotneosebechange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajpodizvajalci(){
            if(!this?.kontrola?.podizvajalci)
                this.kontrola.podizvajalci=[];

            const newRecord = { 
				naziv:"",
				naslov:"",
				dejavnost:"",
				datumzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.podizvajalci.push(newRecord);
        }   ,
        removepodizvajalci(e){
        
                var index=this.kontrola.podizvajalci.indexOf(e);
                if(index>=0)
                        this.kontrola.podizvajalci.splice(index,1)

        },
        podizvajalcichange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajstoritvepodizvajalca(){
            if(!this?.kontrola?.storitvepodizvajalca)
                this.kontrola.storitvepodizvajalca=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.storitvepodizvajalca.push(newRecord);
        }   ,
        removestoritvepodizvajalca(e){
        
                var index=this.kontrola.storitvepodizvajalca.indexOf(e);
                if(index>=0)
                        this.kontrola.storitvepodizvajalca.splice(index,1)

        },
        storitvepodizvajalcachange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		
		dodajizvajalcikontrole(){
            if(!this?.kontrola?.izvajalcikontrole)
                this.kontrola.izvajalcikontrole=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.izvajalcikontrole.push(newRecord);
        }   ,
        removeizvajalcikontrole(e){
        
                var index=this.kontrola.izvajalcikontrole.indexOf(e);
                if(index>=0)
                        this.kontrola.izvajalcikontrole.splice(index,1)

        },
        izvajalcikontrolechange: function (e) {
            e.dataItem[e.field]=e.value;
		},

		authorize(event) {
			event.headers=authHeader();
		},
		onAdd(event) {
		
        this.files=event.newState;
      },
      onRemove(event) {
        this.files=event.newState;
      },
      onProgress(event) {
		console.log("progres");
		console.log(event);
		this.files=event.newState;
      },
      onStatusChange(event) {
		
		console.log("done");
		console.log(event)
		this.files=event.newState;
		Vue.set(this.kontrola,'seznam',{datotekaid:event.response?.response?._id,files:this.files});
      },

		saveData(e){
          //this.save( this.dataSezona);
        },
		handleSubmit(e){

		e.preventDefault();
		},
		onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			console.log(this.ipobsegcertificiranjafilter[podshema])
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;
		 let sezona=this.dataSezona.sezona;
		 let shema="IP";
		 let pridelovalecid=this.pridelovalecid;
		 let thisComp=this;
		 var sifranti=[
		  this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjiip"}).then(

		  	data=>{
				this.kontrolorji=this.sifrant["kontrolorjiip"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
			//mogoče filter po vrsti
		this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja)
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
				
        }),
		this.naloziSifrant({sezona:sezona,sifrant:"podrocjaip"}).then(()=>{
            thisComp.podrocjaip=thisComp.sifrant["podrocjaip"];
		})];
		
		Promise.all(sifranti).then(()=>{
			console.log("Šifranti naloženi")
        

          
		this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{

			console.log("Grem po stranko")
			
			let kontaktkmg=p.kontakt.find(k=>k.vloga=="kmetija (kmg)")
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt.find(k=>k.glavni)
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt[0];

			let nosileckmg=p.kontakt.find(k=>k.vloga=="nosilec kmg")
                if(!nosileckmg)
					nosileckmg=p.kontakt.find(k=>k.glavni)
                if(!nosileckmg)
					nosileckmg=p.kontakt[0];
			this.kontaktkmg=kontaktkmg;
			this.nosileckmg=nosileckmg;
			let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
		if(!pridelava){
			//javi napako, ne dodaj podatkov
			console.log("resne težave, če ni sheme")
			return;
		}
		//naloži kontrolo, če je id, če ni, napaka...
		this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
		let novaprijava={
		obseg:{},
		seznam:{datotekaid:null,files:[]},
		datumseznama:(new Date()).toISOString()};

		if(!pridelava.ip)
		{
			Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		if(!pridelava.ip.prijava){
		Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		Vue.set(thisComp,"ip",pridelava.ip)
		thisComp.files=thisComp.ip.prijava?.seznam?.files;
		
		if(!thisComp.ip.prijava.obseg||Array.isArray(thisComp.ip.prijava.obseg))
		Vue.set(thisComp.ip.prijava,'obseg',{});

		this.ip.prijava.datumseznama=provideIntlService(thisComp).parseDate( this.ip.prijava.datumseznama)

		kontrolaService.loadOne(sezona,pridelovalecid,shema,this.kontrolaid).then(
			data=>{

				
				var datumi=["datumkontrole","datumnadzora","zacetekkontrole","koneckontrole","datumnajave"]
				//vzorci datum pregleda
				//datumzadnjeaktivnosti podizvajalci in stortivepodizvajalca
				//izvajalcikontrole datum
				data.vzorci.forEach(v=>{
					v.datumvzorcenja=provideIntlService(thisComp).parseDate( v.datumvzorcenja);
					v.datumizvida=provideIntlService(thisComp).parseDate( v.datumizvida);
					v.datumpregleda=provideIntlService(thisComp).parseDate( v.datumpregleda);
					
				})
				data.ukrepizvajalca.forEach(v=>{
					v.rok=provideIntlService(thisComp).parseDate( v.rok);
					v.podaljsanrok=provideIntlService(thisComp).parseDate( v.podaljsanrok);
					v.datum=provideIntlService(thisComp).parseDate( v.datum);
					
				})
				//kontrolor v kontrolorji
				if(!data.kontrolorji)
					data.kontrolorji=[];
				if(!data.kontrolorji.includes(data.kontrolornaziv))
					data.kontrolorji.push(data.kontrolornaziv);

				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
				}
				if(!data.neskladja)
					data.neskladja=[];
				data.prisotnaoseba=data.prisotneosebe.find(i=>i.status.id!=3)?data.prisotneosebe.find(i=>i.status.id!=3):{ime:"",status:{ime:"",naziv:""}};
				data.drugeprisotneosebe=data.prisotneosebe.filter(i=>i._id!=data.prisotnaoseba._id).map(p=>p.ime+" ("+p.status.naziv+")")
				data.lokacijakontrole=data.lokacijakontrolenaslov+ ", "+data.lokacijakontrolepostnastevilka + " " +data.lokacijakontroleposta
				Vue.set(thisComp,'kontrola',data);

			
				let paged = new Previewer();
      			paged.preview();

			},
			err=>{}
		);

		

	  

		});

	});
          
        
      
        },
		
        sifranKontrolaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
        sifrantNacinChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


           
            if(!dataItem.oldValues["nacinkontrole"])
              dataItem.oldValues["nacinkontrole"] =dataItem["nacinkontrole"];



      
              Vue.set( dataItem, 'nacinkontrole',e.value.naziv);
            
    
        },
          sifranMnenjeChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            
            if(!dataItem.oldValues["mnenjekontrolorja"])
              dataItem.oldValues["mnenjekontrolorja"] =dataItem["mnenjekontrolorja"];

            Vue.set( dataItem, 'mnenjekontrolorja',e.value.naziv);
            
            
    
        },
        sifranMestoChange: function(e,dataItem) {

          
if(!dataItem.oldValues)
dataItem.oldValues={}



if(!dataItem.oldValues["mestokontrole"])
dataItem.oldValues["mestokontrole"] =dataItem["mestokontrole"];

Vue.set( dataItem, 'mestokontrole',e.value.naziv);



},

        kontrolorChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["kontrolorid"])
              dataItem.oldValues["kontrolor"] =dataItem["kontrolor"];

         
            Vue.set( dataItem, 'kontrolor',e.value.id);
            this.test=e.value.id
         
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontrolepridelovalca"][0].id,
                  vrstakontrole:this.sifrant["vrstakontrolepridelovalca"][0].naziv,
                  nacinkontrole:this.sifrant["nacinkontrolepridelovalca"][0].naziv,
                  mestokontrole:this.sifrant["mestokontrolepridelovalca"][0].naziv,
                  //mestokontrole:"",
                  mnenjekontrolorjaid:this.sifrant["mnenjekontrolorja"][0].id,
                  mnenjekontrolorja:this.sifrant["mnenjekontrolorja"][0].naziv
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
        //tu je treba dodat še shemo...
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'kontrola', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id} });
             //this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
             // });



        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        async shraniKontrole () {
			//kaj narediš s seznamom in obsegom.... vprašaj...
			this.save( this.dataSezona);
			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid)
			
			//shrani obseg...

              //this.save();
    },
       
        
    }
};
</script>

